var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<page ng-class=\"{ 'client-view': auth.roles.client &amp;&amp; ! auth.roles.clientPlus }\" class=\"fleet-dashboard\">\n  <page-header>\n    <page-title></page-title>\n    <div class=\"filters\">\n      <select ng-options=\"route as route.nameAndDriver(drivers) for route in routePlan.routes | orderBy: 'name'\" ng-model=\"map.route\" ng-change=\"map.selectRoute(map.route)\">\n        <option value=\"\">{{ t('fleetDashShowAllRoutes') }}</option>\n      </select>\n    </div>\n  </page-header><map></map>\n  <fleet-dashboard-stats></fleet-dashboard-stats>\n</page>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/pages/fleetDashboardMap.jade
 ** module id = 45
 ** module chunks = 1
 **/